
import Vue from 'vue';
import Component from 'vue-class-component';
import config from '@/config';

@Component
export default class SSOAccountBindingView extends Vue {
  get platform() {
    return this.$store.getters['platform/getPlatform'];
  }

  get logoUrl() {
    const logoPath = this.platform.style.logoUrl;
    return logoPath && `${config.apiUrl}/api${logoPath}`;
  }
}
